import * as form from '../form';

export const legalAssociationsViolentActs = (data = {}) => ({
  HasViolentAct: form.branch(data.HasViolentAct),
  HateCrimes: form.collection(((data.HateCrimes || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  }), data.HateCrimes?.branch),
  GovermentOfficials: form.collection(((data.GovermentOfficials || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  }), data.GovermentOfficials?.branch),
  GovernmentProperty: form.collection(((data.GovernmentProperty || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Has: form.branch(xitem.Has),
        Was: form.branch(xitem.Was),
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  }), data.GovernmentProperty?.branch),
});
